<!--  -->
<template>
  <div class="status" :class="statusClass">
    <span v-if="type === 'author'" class="icon" :class="authorClass"></span>
    <span v-else class="icon" :class="type"></span>
    <span v-if="type !== 'loading' || type !== 'author'">{{ statusObj[type] }}</span>
    <span v-if="type === 'author'">{{ author? '已授权': '尚未授权' }}</span>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'success'
    },
    author: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      statusObj: {
        'warning': '适中',
        'failed': '偏慢',
        'success': '良好',
      },
    };
  },

  components: {},

  computed: {
    statusClass() {
      return {
        'left': this.type === 'loading',
        'right': this.type !== 'loading',
      }
    },
    authorClass() {
      return this.author ? 'success' : 'ua'
    }
  },

  mounted() {},

  methods: {}
}

</script>
<style lang='less' scoped>
.status {
  position: absolute;
  top: 3px;
  display: flex;
  align-items: center;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(51,51,51,1);
}
.left { left: 75px;}
.right { right: 50px}
.icon {
  margin-right: 3px;
  width: 16px;
  height: 16px;
}
.warning {
  background: url('../../assets/check_network/warning.png') no-repeat;
  background-size: 100% 100%;
  .icon;
}
.failed {
  background: url('../../assets/check_network/failed.png') no-repeat;
  background-size: 100% 100%;
  .icon;
}
.success {
  background: url('../../assets/check_network/success.png') no-repeat;
  background-size: 100% 100%;
  .icon;
}
.ua {
  background: url('../../assets/check_network/unauthorized.png') no-repeat;
  background-size: 100% 100%;
  .icon;
}
.loading {
  background: url('../../assets/check_network/loading.png') no-repeat;
  background-size: 100% 100%;
  .icon;
  animation: mymove 1s infinite linear;
}
@keyframes mymove
{
  0% {transform:rotate(0deg);}
  100% {transform:rotate(360deg)}
}
</style>